module.exports = __webpack_public_path__ + "img/icon-package-validity-dark.a51d0c1.svg";